const style={
  tableBody:{
    
  }
}

export default style;
